import { CreateOfferRequest, Offer } from '@/types/offer/offer.types';
import http from './http';

export type OfferStage = 'CONTACTED' | 'INTERVIEW' | 'PROBATION' | 'HIRED' | 'REJECTED';

export const offerApi = {
  create: (body: CreateOfferRequest) => http.post<Offer>('/offers', body).then((r) => r.data),

  getList: (params: { entityType?: string; receiverId?: string; senderId?: string; [key: string]: any }) =>
    http.get<any>('/offers', { params }).then((r) => r.data?.data || r.data),

  updateStatus: (id: string, status: 'accepted' | 'rejected') =>
    http.patch<Offer>(`/offers/${id}`, { status }).then((r) => r.data),

  updateStage: (id: string, stage: OfferStage) =>
    http.patch<Offer>(`/offers/${id}/stage`, { stage }).then((r) => r.data),
};
